import React from 'react'
import Settings from '../Components/Admin/Settings'

function SettingsPage() {
    return (
        <>
            <Settings />
        </>
    )
}

export default SettingsPage
